import * as types from './types';

export const refreshServices = () => ({
  type: types.CHANGE_SERVICE_VERSION
});
